import moment from 'moment'
import React from 'react'
import {Button, Card, Tooltip, notification, Select, Tabs, DatePicker, Row, Col} from 'antd'
import _ from 'lodash'
import {TableComp, FormUtils as GetAllFormFields} from 'sz-react-utils'

import ListFollowUps from "./listInvoiceFollowUp";
import InvoiceView from '../DocumentViews/invoiceView';
import InboxEmailView from '../Invoice/inboxEmailView';
import InvoiceUpdateForm from '../Invoice/invoiceUpdateForm';
import LatestFollowUp from "./latestFollowup";

import Request from '../../request'
import { connect } from 'react-redux'
import styles from '../../containers/Desk/counselling/all/styles.less'
import { RightsWrapper } from './utils'
const Option = Select.Option
const { RangePicker } = DatePicker
let invoiceObj = {};

class AllInvoiceFollowUp extends React.Component {
    state = {
        id: '',
        total: 0,
        activeTab: '0',
        refreshChild: false,
        bonusAny: '',
        universityId: '',
        universities: [],
        courses: [],
        showInvoiveView: false,
        showInvoiveInboxView: false,
        showInvoiceUpdateForm: false,
        generatedInvoice: {},
        universityInstitutionName: '',
        invoiceId: '',
        branchId: '',
        branchs: [],
        time: {
            from: null,
            to: null
        },
    }

    apiRequest = params => {
        return new Promise(async resolve => {
            params.time = this.state.time;
            params.branchId = this.state.branchId;
            if (this.state.universityInstitutionName) {
                params.universityInstitutionName = this.state.universityInstitutionName;
            }
            this.setState({ exportParams: params })
            let data = await Request.loadTodayInvoiceFollowUp({
                ...params,
                regExFilters: [
                    'invoiceNumber',
                ],
                sortField: 'invoiceGeneratedDate',
                sortOrder: 'decend'
            })
            this.setState({ total: data.total })
            resolve(data)
        })
    }
    loadUniversity = async () => {
        Request.loadSimpleUniversities({ sort: { instituteName: 1 } })
            .then(resp => {
                resp.arr = resp.arr.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.universityInstitutionName })
                    return temp
                }, [])

                this.setState({ universities: resp.arr });
                this.refreshFxn()
            })
            .catch(err => {
                console.log(err)
            })
    }
    componentWillMount() {

    }

    async componentDidMount() {
        await this.loadUniversity();
    }

    constructor(props) {
        super(props)
        this.table = React.createRef();
        this.loadBranches();
    }
    showInvoive = (record) => {
        this.setState({ showInvoiveView: true, invoiceId: record._id });
    }
    closeDocument = () => {
        this.setState({ showInvoiveView: false });
    }

    sendInvoice = (invoiceId) => {
        this.setState({ showInvoiveInboxView: true, invoiceId: invoiceId });
    }
    updateInvoice = (invoiceId) => {
        this.setState({ showInvoiceUpdateForm: true, invoiceId: invoiceId });
    }
    createNewInvoice = async (invoiceId) => {
        let response = await Request.createNewInvoice({ invoiceId });
        if (response.error) {
            return notification.error({
                message: response.msg
            })
        } else {
            this.table.current.reload();
            return notification.success({
                message: response.msg
            })
        }
    }

    closeInvoiceInbox = () => {
        this.setState({ showInvoiveInboxView: false });
        let $this = this;
        setTimeout(function () {
            if ($this.table && $this.table.current) {
                $this.table.current.reload();
            }
        }, 500);
    }

    closeInvoiceUpdateForm = () => {
        this.setState({ showInvoiceUpdateForm: false });
        let $this = this;
        setTimeout(function () {
            if ($this.table && $this.table.current) {
                $this.table.current.reload();
            }
        }, 500);
    }

    loadBranches = () => {
        let params = {
            sortField: 'branchName',
            sortOrder: 'ascend',
            results: 1000,
            count: 1000,
            status: true
        }
        Request.loadBranch({ ...params })
            .then(resp => {
                resp.data = resp.data.reduce((temp, vv) => {
                    temp.push({ id: vv._id, display: vv.branchName })
                    return temp
                }, [])
                this.setState({ branchs: resp.data });
            })
            .catch(err => {
                console.log(err)
            })
    }

    chooseRangerPicker = (date, dateString) => {
        this.setState(
            {
                time: {
                    from: date[0],
                    to: date[1]
                }
            }, () => {
                if (date[0] == undefined) {
                    if (this.table && this.table.current) {
                        this.table.current.reload();
                    }
                }
            }
        )
    }

    onOk = value => {
        if (this.table && this.table.current) {
            this.table.current.reload();
        }
    }

    openFollowUps = (record) => {
        invoiceObj = {
            invoiceToName: record.invoiceToName,
            _id: record._id,
        };
        this.setState({ showFollowUp: true });
    };

    closeFollowUp = () => {
        this.setState({
            showFollowUp: false,
        }, () => {
            this.table.current.reload()
        });
    };

    render() {
        const { dispatch } = this.props

        const { total, showInvoiveView, invoiceId, showInvoiveInboxView, showInvoiceUpdateForm, branchs } = this.state;
        const columns = [
            {
                title: "View Summary",
                key: "operation",

                width: 130,
                render: (text, record) => (
                    <div className={styles.btnWrapper}>
                        <React.Fragment>
                            {
                                record.invoiceStatus == 'Generated' && record.invoiceType == 'Invoice' ?
                                    <Tooltip title="Send invoice to recipient">
                                        <Button
                                            loading={false}
                                            className={styles.btn}
                                            onClick={() => { this.sendInvoice(record._id) }}
                                            shape="circle"
                                            icon="forward"
                                        />
                                    </Tooltip>
                                    : null
                            }
                            {
                                record.invoiceStatus == 'Sent' ?
                                    <Tooltip title="Update Invoice">
                                        <Button
                                            loading={false}
                                            className={styles.btn}
                                            onClick={() => { this.updateInvoice(record._id) }}
                                            shape="circle"
                                            icon="edit"
                                        />
                                    </Tooltip>
                                    : null
                            }
                            <Tooltip title="View Invoice ">
                                <Button
                                    loading={false}
                                    className={styles.btn}
                                    onClick={() => { this.showInvoive(record) }}
                                    shape="circle"
                                    icon="eye"
                                />
                            </Tooltip>
                            {
                                record.invoiceStatus == 'Draft' && record.invoiceType == 'Performa' ?
                                    <Tooltip title="Create Original Invoice">
                                        <Button
                                            loading={false}
                                            className={styles.btn}
                                            onClick={() => { this.createNewInvoice(record._id) }}
                                            shape="circle"
                                            icon="plus"
                                        />
                                    </Tooltip>
                                    : null
                            }
                            {
                                record.invoiceStatus == 'Draft' || record.invoiceStatus == 'Sent' || record.invoiceStatus == 'Generated' ?
                                    <Tooltip title="FollowUps">
                                        <Button
                                            className={styles.btn}
                                            size={"small"}
                                            shape="circle"
                                            onClick={() => this.openFollowUps(record)}
                                            icon="calendar"
                                        />
                                    </Tooltip>
                                    : null
                            }
                        </React.Fragment>
                    </div>
                ),
            },
            {
                title: 'Invoice',
                key: 'invoiceNumber',
                dataIndex: 'invoiceNumber',
                width: 170,
                searchTextName: 'invoiceNumber',
                render: (text, record) => (
                    <div className={styles.wrap}>
                        <React.Fragment>
                            <div>
                                <div><b>Number:-</b> {record.invoiceNumber}</div>
                                <div><b>Status:-</b> {record.invoiceStatus}</div>
                                <div><b>Type:-</b> {record.invoiceType}</div>
                            </div>
                        </React.Fragment>
                    </div>
                )
            },
            {
                title: 'Institute/Course',
                key: 'universityInstitutionName',
                dataIndex: 'universityInstitutionName',
                width: 210,
                render: (text, record) => (
                    <div className={styles.wrap}>
                        <React.Fragment>
                            <div>
                                <div><b>Institute:-</b> {record.universityInstitutionName}</div>
                            </div>
                        </React.Fragment>
                    </div>
                )
            },
            {
                title: 'Invoice Details',
                key: 'invoices',
                dataIndex: 'invoices',
                width: 210,
                render: (text, record) => (
                    <div className={styles.wrap}>
                        <React.Fragment>
                            <div>
                                {
                                    record.invoices ?
                                        record.invoices.map((invoice, index) => {
                                            return (<div key={index}>
                                                <div><b>Student Name:-</b> {invoice.studentName}</div>
                                                <div><b>Student Mobile:-</b> {invoice.studentMobile}</div>
                                                <div><b>Student ID:-</b> {invoice.instituteStudentId}</div>
                                                <br />
                                            </div>)
                                        })
                                        : null
                                }
                            </div>
                        </React.Fragment>
                    </div>
                )
            },
            {
                title: 'Commission Details',
                key: 'commissionGrandTotal',
                filterRegex: true,
                width: 210,
                render: (text, record) => (
                    <div className={styles.wrap}>
                        <React.Fragment>
                            <div>
                                <div><b>Sub Total:-</b> {record.invoices && record.invoices.length > 0 ? record.invoices[0].currency : ''} {record.commissionSubTotal.toFixed(2)} </div>
                                <div><b>Tax:-</b> {record.invoices && record.invoices.length > 0 ? record.invoices[0].currency : ''} {record.commissionTaxTotal.toFixed(2)} <small>({record.commissionTaxType}-{record.commissionTax}%)</small></div>
                                <div><b>TOTAL:-</b> {record.invoices && record.invoices.length > 0 ? record.invoices[0].currency : ''} {record.commissionGrandTotal.toFixed(2)}</div>
                            </div>
                        </React.Fragment>
                    </div>
                )
            },
            {
              title: "Follow Up",
              key: "followUp",
              width: 200,
              searchTextName: "followUp",
              filterRegex: true,
              dataIndex: "followUp",
              render: (text, record) => {
                return <LatestFollowUp info={text} />;
              },
            },
            {
                title: 'Created By',
                width: 150,
                key: 'createdByUser',
                // searchDateName: 'createdByUser.time',
                render: (text, record) => {
                    return (
                        <div>
                            <div >{text ? text.name : ''}</div>
                            <small>{text ? moment(text.time).format('lll') : ''}</small>
                        </div>
                    )
                }
            },
        ];

        return (
            <RightsWrapper myRight={"financeInvoiceFollowup.view"}>
            <div>
                {
                    showInvoiveView ?
                        <InvoiceView invoiceId={invoiceId} onClose={this.closeDocument} onSendInvoice={(invoiceId) => { this.sendInvoice(invoiceId) }} />
                        : null
                }

                {
                    showInvoiveInboxView ?
                        <InboxEmailView invoiceId={invoiceId} onClose={this.closeInvoiceInbox} />
                        : null
                }

                {
                    showInvoiceUpdateForm ?
                        <InvoiceUpdateForm invoiceId={invoiceId} onClose={this.closeInvoiceUpdateForm} />
                        : null
                }

                {
                    this.state.showFollowUp ? (
                        <ListFollowUps invoiceObj={invoiceObj} onClose={this.closeFollowUp} />
                    )
                        : null
                }
                <Card style={{ marginBottom: 10 }}
                    title={`Today's Pending Invoices Reminder:- ${total}`}
                    headStyle={{ paddingTop: '5px' }}
                    bordered={false}>
                    <Row>
                        <Col span={6}>
                            <div>
                                <h4>Show By Branch</h4>
                                <Select
                                    allowClear
                                    style={{ width: '250px' }}
                                    showSearch={true}
                                    value={this.state.branchId}
                                    placeholder="Select Option"
                                    optionFilterProp="display"
                                    filterOption={(input, option) => {
                                        return (
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        )
                                    }}
                                    onChange={branchId => {
                                        this.setState(
                                            {
                                                branchId: branchId && branchId.toString()
                                            },
                                            () => {
                                                setTimeout(() => {
                                                    this.table.current.reload();
                                                }, 500);
                                            }
                                        )
                                    }}>
                                    {branchs.map((val, idn) => {
                                        return (
                                            <Option key={idn} value={val.id}>
                                                {val.display}
                                            </Option>
                                        )
                                    })}
                                </Select>
                            </div>
                        </Col>
                        <Col span={8}>
                            <h4>Filter by Date</h4>
                            <RangePicker
                                showTime={{ format: 'HH:mm' }}
                                format="YYYY-MM-DD HH:mm"
                                placeholder={['Start Date', 'End Date']}
                                onChange={this.chooseRangerPicker}
                                onOk={this.onOk}
                            />
                        </Col>
                        <Col span={6}>
                            <h4>Search By University</h4>
                            <Select
                                allowClear
                                style={{ width: '250px' }}
                                showSearch={true}
                                placeholder="Select University"
                                optionFilterProp="universityInstitutionName"
                                onChange={(v) => this.setState({ universityInstitutionName: v }, () => { this.table.current.reload(); })}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    )
                                }}>
                                {
                                    this.state.universities.map((val, idn) => {
                                        return (
                                            <Option key={idn} value={val.display}>
                                                {val.display}
                                            </Option>
                                        );
                                    })
                                }
                            </Select>
                        </Col>
                    </Row>
                </Card>
                <Card bordered={true}>
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        extraProps={{ scroll: { x: 900 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 10,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </div>
            </RightsWrapper>    
        );
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AllInvoiceFollowUp)
